/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { overviewFiltersInputDataDirectionSchema } from './OverviewFiltersInputDataDirectionSchema'
import { overviewFiltersInputDataSortSchema } from './OverviewFiltersInputDataSortSchema'

export const overviewFiltersInputDataSchema = z.object({
	page: z.number().optional().default(1),
	perPage: z.number().optional().default(25),
	sort: overviewFiltersInputDataSortSchema.optional().default('created_at'),
	direction: overviewFiltersInputDataDirectionSchema.optional().default('desc'),
	status: z.array(
		z.union([
			z.literal('draft'),
			z.literal('review'),
			z.literal('publishing'),
			z.literal('active'),
			z.literal('completed'),
		]),
	).optional().default([]),
	from: z.iso.datetime().nullable().optional(),
	to: z.iso.datetime().nullable().optional(),
	campaignIds: z.array(z.string()).optional().default([]),
})

export type OverviewFiltersInputDataSchema = z.infer<typeof overviewFiltersInputDataSchema>
